module.exports = __webpack_public_path__ + "img/noData.618922f2.png";